import { DateInput, FormControl, FormField, FormItem, FormLabel } from '@kalos/ui';
import { format } from 'date-fns';

import { JobSelector } from '../../../../components/JobSelector';
import { type MemoExportLockedFields, useMemoExportFormContext } from './MemoExportUtils';

interface MemoExportFilterProps {
  lockedFields?: MemoExportLockedFields;
  disabled?: boolean;
}

export const MemoExportFilter = ({ lockedFields, disabled }: MemoExportFilterProps) => {
  const form = useMemoExportFormContext();

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <FormField
          control={form.control}
          name="eventId"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-sm font-medium text-gray-700">Job Number</FormLabel>
              <FormControl>
                <JobSelector
                  value={field.value || 0}
                  onChange={(value) => field.onChange(value || undefined)}
                  disabled={disabled || lockedFields?.eventId}
                  omitArchivedJobs
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="startDate"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-sm font-medium text-gray-700">From Date</FormLabel>
              <FormControl>
                <DateInput
                  {...field}
                  value={field.value ? new Date(field.value) : undefined}
                  disabled={disabled || lockedFields?.startDate}
                  onChange={(date) => field.onChange(date ? format(date, 'yyyy-MM-dd') : undefined)}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="endDate"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="text-sm font-medium text-gray-700">To Date</FormLabel>
              <FormControl>
                <DateInput
                  {...field}
                  value={field.value ? new Date(field.value) : undefined}
                  disabled={disabled || lockedFields?.endDate}
                  onChange={(date) => field.onChange(date ? format(date, 'yyyy-MM-dd') : undefined)}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
